import Base from './condition-base'
import renderFields from './audio-finish.pug'

export default class AudioFinish extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
